import styled from 'styled-components';

const DebugBarWrapper = styled.div`
  position: fixed;
  display: flex;
  bottom: 0;
  right: 0;
  width: auto;
  z-index: 1000;
`;

export default DebugBarWrapper;



// WEBPACK FOOTER //
// ./src/blocks/DebugComponents/DebugBar/DebugBarWrapper.jsx